import React from 'react';
import s from '../../PersonalOffice/Education/MainEducation.module.css';
import {useNavigate} from 'react-router-dom';

const EducationBackButton = () => {
	const navigate = useNavigate();
	return (
		<button onClick={() => navigate('/')} className={s.backButton}>
			{/*{"<<< Повернутися"}*/}
			{'В кабінет'}
		</button>
	);
};

export default EducationBackButton;
